/* global AWIN */
import createAdapter from './createAdapter'
import { getItem, setItem, removeItem } from '../../storeManager'
import { environment } from 'js/config'
import { excludeVAT } from '../../utils'

export const awin = createAdapter(() => true, {
  trackPurchase(transactionId, coupon, orderValue, currency) {
    console.log('[Awin Adapter] trackPurchase called', {
      transactionId,
      coupon,
      orderValue,
      currency,
      hasAWIN: !!window.AWIN,
    })

    if (!getItem('state')) {
      console.error('[Awin Adapter] Error: no state saved')
      throw new Error('awinAdapter.ts error: no state saved')
    }

    const { user: userState, locale: localeState } = JSON.parse(
      getItem('state') as string,
    )
    const awc = getItem('awinAwc')
    const userId = userState.profile.id || userState.limitedProfile.id
    const country = userState.profile.country || localeState.country
    let merchantId: string = '113414'

    const couponUpper = coupon ? coupon.toUpperCase() : ''
    const isAwinCoupon =
      couponUpper === 'AWINCA' ||
      couponUpper === 'AWINUS' ||
      awc?.toUpperCase() === 'AWINCA' ||
      awc?.toUpperCase() === 'AWINUS'

    console.log('[Awin Adapter] State check', {
      awc,
      userId,
      country,
      coupon,
      isAwinCoupon,
    })

    if (userId && (awc || isAwinCoupon)) {
      if (coupon) {
        const couponUpper = coupon.toUpperCase()
        switch (couponUpper) {
          case 'AWINCA':
            merchantId = '119213'
            coupon = 'AwinCA'
            break
          case 'AWINUS':
            merchantId = '119217'
            coupon = 'AwinUS'
            break
        }
      } else if (awc) {
        const awcUpper = awc.toUpperCase()
        switch (awcUpper) {
          case 'AWINCA':
            merchantId = '119213'
            coupon = 'AwinCA'
            break
          case 'AWINUS':
            merchantId = '119217'
            coupon = 'AwinUS'
            break
        }
      } else {
        coupon = null
      }
      console.log('[Awin Tracking] Coupon: ', coupon, merchantId)
      var amount = parseFloat(excludeVAT(orderValue, country)).toFixed(2)
      console.log('[Awin Adapter] Awin Coupon:', coupon)
      console.log('[Awin Adapter] Selected merchantId:', merchantId)
      console.log('[Awin Adapter] Amount (ex VAT):', amount)

      var awPixel = new Image(0, 0)
      const pixelUrl =
        'https://www.awin1.com/sread.img?tt=ns&tv=2&merchant=' +
        merchantId +
        '&amount=' +
        amount +
        '&ch=aw&parts=DEFAULT:' +
        amount +
        '&ref=' +
        transactionId +
        '&vc=' +
        (coupon || '') +
        '&cr=' +
        currency +
        '&testmode=' +
        (environment === 'production' ? 0 : 1)
      awPixel.src = pixelUrl
      document.getElementsByTagName('body')[0].appendChild(awPixel)

      console.log('[Awin Adapter] Awin pixel URL:', pixelUrl)
      console.log(
        '[Awin Adapter] Pixel sent (works even if mastertag script is blocked)',
      )

      // Optionally use AWIN.Tracking.run() if available (enhanced tracking)
      // This is a bonus but not required - pixel tracking above is sufficient
      if (window.AWIN && window.AWIN.Tracking) {
        AWIN.Tracking.Sale = {
          amount: '' + amount,
          channel: 'aw',
          orderRef: '' + transactionId,
          parts: 'DEFAULT:' + amount,
          currency: '' + currency,
          voucher: '' + (coupon || ''),
          test: '' + (environment === 'production' ? 0 : 1),
        }

        console.log(
          '[Awin Adapter] AWIN.Tracking.Sale set (enhanced tracking):',
          AWIN.Tracking.Sale,
        )
        AWIN.Tracking.run()
        console.log('[Awin Adapter] AWIN.Tracking.run() executed')
      } else {
        console.log(
          '[Awin Adapter] AWIN.Tracking not available (likely blocked by ad blocker)',
        )
        console.log(
          '[Awin Adapter] Pixel tracking sent successfully - this is sufficient for tracking',
        )
      }

      removeItem('awinAwc')
    } else {
      console.warn(
        '[Awin Adapter] Skipping tracking - missing userId or Awin coupon',
        {
          awc,
          userId,
          coupon,
          isAwinCoupon,
        },
      )
    }
  },
  saveId() {
    const awc = new URLSearchParams(document.location.search).get('awc')
    if (awc) {
      const awcUpper = awc.toUpperCase()
      if (awcUpper === 'AWINCA' || awcUpper === 'AWINUS') {
        setItem('awinAwc', awc)
        console.log('[Awin Adapter] Saved awc to localStorage:', awc)
      } else {
        setItem('awinAwc', awc)
        console.log('[Awin Adapter] Saved awc to localStorage:', awc)
      }
    }
  },
})
